import { ControlSource } from "arcjs/control_source/index";

export const OfflineARCHost = process.env.REACT_APP_HOST_OVERRIDE || window.location.hostname;

export const DefaultControlSource =
    process.env.REACT_APP_CONTROL_SOURCE || ControlSource.ROSLIBJS.name;

export const ConnectionState = {
    Connected: "Connected",
    Connecting: "Connecting",
    Disconnected: "Disconnected",
    Error: "Error",
    Timeout: "Timeout",
};
